module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/locks/locks-delete/locks-delete.component.css
// module id = ./src/app/locks/locks-delete/locks-delete.component.css
// module chunks = main